import React, { useEffect } from 'react'
import { Location } from '@reach/router'
import { useSelector } from 'react-redux'

import { useMessagesActions } from '../../state/actions/messages'

function messageTypeToCSSClass(messageType) {
  switch (messageType) {
    case 'success':
      return 'is-success'
    case 'loading':
      return 'is-info'
    case 'warn':
      return 'is-warning'
    case 'error':
      return 'is-danger'
    default:
      return 'is-info'
  }
}

function MessageListItem({ message }) {
  const { removeMessage } = useMessagesActions()

  useEffect(() => {
    setTimeout(() => {
      removeMessage(message.id)
    }, 10000)
  }, [message])

  return (
    <section className="section" style={{ padding: '1rem 0' }}>
      <div className={`notification ${messageTypeToCSSClass(message.type)}`}>
        <button
          className="delete"
          onClick={() => removeMessage(message.id)}
        ></button>
        <div dangerouslySetInnerHTML={{ __html: message.text }} />
      </div>
    </section>
  )
}

function MessageList({ location, messages }) {
  // const { clearMessages } = useMessagesActions()

  // useEffect(() => {
  //   clearMessages()
  // }, [location, clearMessages])

  return messages.map((msg, i) => <MessageListItem key={i} message={msg} />)
}

export default () => {
  const messages = useSelector((state) => state.messages)

  return (
    <Location>
      {({ location }) => (
        <>
          <MessageList location={location} messages={messages} />
        </>
      )}
    </Location>
  )
}
